import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';

const UploadFilesFieldSchema = makeFieldSchema({
  output: z => z.array(z.string()),
  uiOptions: z =>
    z.object({
      componentName: z
        .string()
        .optional()
        .describe(
          'The name of the component to which the files will be uploaded. This is used to determine the S3 prefix and tagging for the uploaded files. Either componentName or projectSlug must be provided.',
        ),
      projectSlug: z
        .string()
        .optional()
        .describe(
          'The project slug to which the files will be uploaded. This is used to determine the S3 prefix and tagging for the uploaded files. Either projectSlug or componentName must be provided.',
        ),
      s3Bucket: z
        .string()
        .optional()
        .describe(
          'The S3 bucket where the files will be uploaded. If not provided, a default bucket from the configuration will be used.',
        ),
      s3Prefix: z
        .string()
        .optional()
        .describe(
          'The S3 prefix (folder path) where the files will be uploaded. If not provided, a default prefix will be used.',
        ),
    }),
});

export type UploadFilesFieldUiOptions = NonNullable<(typeof UploadFilesFieldSchema.TProps.uiSchema)['ui:options']>;

export type UploadFilesFieldProps = typeof UploadFilesFieldSchema.TProps;

export const UploadFilesSchema = UploadFilesFieldSchema.schema;
